<!-- MapComponent.vue -->
<template>
  <Card>
    <template #content>
      <div id="map" :style="fixedHeight ? { width: '100%', height: fixedHeight } : { width: '100%', height: `${viewportHeight - 200}px` }"></div>

      <div id="controls" class="gap-2 flex items-left">
      <!-- <select id="baseLayerControl" @change="setBaseLayer(($event.target as HTMLSelectElement).value)">  </select>-->
      <!-- <option value="osm">OpenStreetMap</option> -->
        <!-- <option value="google">Google Maps</option> -->
        <div id="baseLayerControlGroup">
          <Button>Base Layer:</Button>
          <Select 
            id="layerSelectDropdown" 
            v-model="selectedBaseLayer" 
            :options="layerOptions" 
            optionLabel="label" 
            optionValue="id" 
            @change="setBaseLayer($event.value)"
          />
        </div>
        <Divider layout="vertical" />
        <Button @click="toggleGraticule">Toggle Grid</Button>
        <!-- <Card>
          <template #header>
            {{mapDescription}}
          </template> 
        </Card> -->
      </div>
      <div id="mapInfo"></div>
    </template>
  </Card>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted } from 'vue'
import type { Ref } from 'vue'
import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import XYZ from 'ol/source/XYZ'
import { fromLonLat, toLonLat } from 'ol/proj'
import Graticule from 'ol/layer/Graticule.js';
import Stroke from 'ol/style/Stroke.js';

import { useMapStore } from '@/stores/mapStore'
import { useViewportHeight } from '../composables/useViewportHeight'

const mapContainer: Ref<Map | null> = ref(null)

export default defineComponent({
  name: 'MapComponent',
  props: {
    fixedHeight: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const { viewportHeight } = useViewportHeight()

    // const layerLabels: { [key: string]: string } = {
    //   osm: 'OpenStreetMap',
    //   google: 'Google Maps',
    //   google_gray: 'Google Maps Grayscale'
    // }

    // 
    const layerOptions = [
      { label: "OpenStreetMap", id: "osm" },
      { label: "Google Maps", id: "google" },
      { label: "Google Maps Grayscale", id: "google_gray" }
    ]
    const selectedBaseLayer = ref(""); // Set the default when mounted

    // @ts-ignore
    const baseLayers: Ref<{ [key: string]: TileLayer<OSM | XYZ> }> = ref({
      osm: new TileLayer({
        source: new OSM()
      }),
      google: new TileLayer({
        source: new OSM({
          url: 'http://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
        })
      }),
      google_gray: new TileLayer({
        source: new OSM({
          url: 'http://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
          // tileLoadFunction: (tile, src) => {
            // const image = tile.getImage() as HTMLImageElement;
            // const canvas = document.createElement('canvas');
            // const context = canvas.getContext('2d');

            // // Load the image, then apply grayscale and render to canvas
            // image.onload = () => {
            //   canvas.width = image.width;
            //   canvas.height = image.height;
            //   // set the filter on the canvas context
            //   context.filter = 'grayscale(100%)';
            //   context.drawImage(image, 0, 0);
            //   tile.getImage().src = canvas.toDataURL();
            // };

            // Set the source URL to load the original image
            // image.src = src;
          // }
          
        }),
        className: 'grayscale-layer'
      })
    })

    const setBaseLayer = (layer: string) => {
      if (mapContainer.value) {
        // remove the layer at the bottom of the layer stack
        mapContainer.value.getLayers().removeAt(0)
        // insert the layer at the bottom of the layer stack
        mapContainer.value.getLayers().insertAt(0, baseLayers.value[layer])
      }
    }

    const graticule = new Graticule({
          // the style to use for the lines, optional.
          strokeStyle: new Stroke({
            color: 'rgba(0,0,0,0.9)',
            width: 1,
            lineDash: [4, 5]
          }),
          // coordinates in decimal degrees, 4 significant digits by default
          latLabelFormatter: (lat) => {
            return Math.round(lat * 10000) / 10000 + '°';
          },
          lonLabelFormatter: (lon) => {
            return Math.round(lon * 10000) / 10000 + '°';
          },
          showLabels: true,
          wrapX: false,
        });

    const toggleGraticule = () => {
      if (!mapContainer.value) {
        console.error('Map not initialized')
        return
      }

      // Check if the graticule is already on the map
      const graticuleLayer = mapContainer.value.getLayers().getArray().find((layer) => layer instanceof Graticule)
      if (graticuleLayer) {
        graticuleLayer.setVisible(!graticuleLayer.getVisible())
      } else {
        mapContainer.value.addLayer(graticule)
      }
      
    }

    // // Populate the base layer control
    // const populateBaseLayerControl = () => {
    //   // Get the base layer control element
    //   const ele = document.getElementById('baseLayerControl')
    //   if (ele) {
    //     // Add the base layer options to the control
    //     Object.keys(baseLayers.value).forEach((layer) => {
    //       const option = document.createElement('option')
    //       option.value = layer
    //       option.text = layerLabels[layer]
    //       ele.appendChild(option)
    //     })
    //   } else {
    //     console.error('Base layer control element not found')
    //   }
    // }

    // Initialize the map
    const initializeMap = () => {
      const mapCenter = fromLonLat([-2, 55])
      const mapZoom = 5.5

      mapContainer.value = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            // source: new OSM()
          })
        ],
        view: new View({
          // popular projection: "EPSG:3857"
          // projection: 'EPSG:3857',
          // projection: 'EPSG:4326',
          center: mapCenter,
          zoom: mapZoom
        })
      })

      // add onclick to map to log the coordinates
      mapContainer.value.on('click', (event) => {
        const coords = event.coordinate
        console.log('Coordinates:', coords)
        // convert to lat lon
        console.log('Lat Lon:', toLonLat(coords))
      })
    }

    onMounted(() => {
      const mapStore = useMapStore()

      initializeMap()
      // populate the base layer control
      // populateBaseLayerControl()

      // Add a control to the map
      // this.mapContainer.addControl(this.baseLayerControl)
      // null check
      if (mapContainer.value) {
        // @ts-ignore
        mapStore.setMap(mapContainer)
        mapStore.crs = 'EPSG:3857'
      }

      // DEFAULTS
      // toggleGraticule loads the graticule when called. Comment out to hide.
      toggleGraticule()
      // Vue doesn't see this as Change event:
      selectedBaseLayer.value = "google"; 
      // So we manually trigger the function:
      setBaseLayer(selectedBaseLayer.value);

            

    })

    return {
      mapContainer,
      viewportHeight,
      initializeMap,
      setBaseLayer,
      // populateBaseLayerControl,
      toggleGraticule,
      graticule,
      layerOptions,
      selectedBaseLayer
    }
  }
})
</script>

<style>
/* Remove the ol-attribution class divs */
.ol-attribution {
  display: none;
}

/* gray */
.grayscale-layer {
  filter: grayscale(100%);
}

.mapDescription {
  width: 50%;
  height: 2rem;
}

#map {
  min-height: 400px;
}

#mapInfo
{
        position: absolute;
        display: inline-block;
        height: auto;
        width: auto;
        z-index: 100;
        background-color: #333;
        color: #fff;
        text-align: center;
        border-radius: 4px;
        padding: 5px;
        left: 50%;
        transform: translateX(3%);
        visibility: hidden;
        pointer-events: none;
}

</style>
